import { ChangeEvent, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { toast } from "react-toastify"

import { Header } from "shared/components/organisms/Header/Header"
import { Sidebar } from "shared/components/organisms/Sidebar/Sidebar"

import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg'
import { ReactComponent as SearchIcon } from 'assets/icons/search-icon.svg'

import api from "services/api"

import { Container, Content, FAQSection, QuestionIcon, ReturnButton } from "./_fAQ"

interface IFAQs {
  id: string;
  title: string;
  content: string;
  showContent: boolean;
}

export const FAQ = () => {
  const [FAQs, setFAQs] = useState([] as Array<IFAQs>)
  const [filteredFAQs, setFilteredFAQs] = useState([] as Array<IFAQs>)

  const [, setSearchQuery] = useState('')

  const toggleFAQContent = (index: number) => {
    const newState = [...filteredFAQs]
    const newBoolean = !newState[index].showContent

    newState[index].showContent = newBoolean

    setFilteredFAQs(newState)
  }

  const filterFAQs = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    setFilteredFAQs(() => {
      const newState = FAQs.filter(({ title }) => {
        const lowerTitle = title.toLowerCase();
        const lowerValue = value.toLowerCase();

        return lowerTitle.includes(lowerValue)
      });

      return newState;
    })

    setSearchQuery(value)
  }

  const ensureFAQs = async () => {
    try {
      const response: any = await api.get('/system-infos/facs/')

      const faqs = response?.data?.facs.map((faqs: IFAQs)  => ({
        ...faqs,
        showContent: false,
      }))

      setFAQs(faqs)
      setFilteredFAQs(faqs)
    } catch (error: any) {
      toast.error(error?.response?.data?.message)
    }
  }

  useEffect(() => {
    ensureFAQs()
  }, [])

  return (
    <Container>
      <Header />
      <Sidebar />

      <Content>
        <ReturnButton to="/suporte">
          <LeftArrow
            className="faq__content-icon"
          />
        </ReturnButton>

        <FAQSection>
          <div className="faq__section-questions-container">
            <label className="faq__section-questions__search-label">
              <input
                className="faq__section-questions__search-input"
                type="text"
                onChange={filterFAQs}
              />
              <div className="faq__section-questions__search-icon">
                <SearchIcon />
              </div>
            </label>

            <ul className="faq__section-questions__list">
              {filteredFAQs.map((faq, i) => (
                <li
                  key={faq?.id}
                  className="faq__section-questions__list-item"
                >
                  <details>
                    <summary
                      className="faq__section-questions__list-item-summary"
                    >
                      <QuestionIcon />
                      <h1
                        className="faq__section-questions__list-item-title"
                      >
                        {faq?.title}
                      </h1>
                    </summary>
                    <p
                      className="faq__section-questions__list-item-p"
                    >
                      {faq?.content}
                    </p>
                  </details>
                </li>
              ))}
            </ul>
          </div>
          <Link
            to="/suporte"
            className="faq__section-help-anchor"
          >
            Sua dúvida não está aqui?
            Entre em contato com
            nosso suporte
          </Link>
        </FAQSection>
      </Content>
    </Container>
  )
}
